import { useCallback, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { styled } from '@stitches/configed';
// import Button from '../Button'
import { Button } from 'antd';
import WarningIcon from '../Icons/WarningIcon';
import BoxStyled from '../Box';
import { ModalProps } from './Modal';
import { CloseCircleOutlined } from '@ant-design/icons';

const Wrap = styled(motion.div, {
  zIndex: 9999,
  display: 'flex',
  position: 'fixed',
  uInset: 0,
  transition: 'opacity .2s ease',
  '-webkit-tap-highlight-color': 'rgba(255,255,255,0)',
  justifyContent: 'center',
  '-webkit-box-pack': 'center',
  alignItems: 'center',
  '-webkit-box-align': 'center',
});
const Main = styled('div', {
  position: 'relative',
  zIndex: 9999,
  transition: 'all .2s ease',
  backfaceVisibility: 'hidden',
});
const Box = styled(BoxStyled, {
  color: '#021337',
  borderRadius: 20,
  maxWidth: 350,
  minHeight: 140,
  lineHeight: 'normal', // fix lineHeight to large if it placed in header
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});
const Icon = styled('div', {
  fontSize: 40,
  marginBottom: 24,
  variants: {
    color: {
      undefined: {
        color: '$brand',
      },
      danger: {
        color: '$danger',
      },
      warning: {
        color: '$warning',
      },
    },
  },
});
const Title = styled('div', {
  fontSize: 24,
  fontWeight: 600,
  marginBottom: 24,
  textAlign: 'center',
});
const Body = styled('div', {
  marginBottom: 24,
  textAlign: 'center',
});
const Control = styled('div', {
  width: '100%',
  padding: '0 16px',
  display: 'flex',
  justifyContent: 'center',
  // uGap: 12,
  'button+button': {
    marginLeft: 12,
  },
  // '& button': {
  //   backgroundColor: '#f9aa19',
  //   border: 0,
  //   borderRadius: '$base',
  //   color: '#000',
  //   margin: '0 $xs',
  //   width: 140,
  //   fontWeight: 600,
  //   '&:hover': {
  //     backgroundColor: '$brand',
  //   },
  // },
});
const Mask = styled('div', {
  backgroundColor: '$mask',
  opacity: 0.5,
  zIndex: 999,
  uInset: 0,
  position: 'fixed',
});

export default function ModalDialog(props: ModalProps) {
  const { visible, heading, message, onClose, onConfirm, subMessage } = props;
  // useEffect(() => {
  //   if (props.visible) {
  //     setVisible(true)
  //   }
  // }, [props.visible])

  const handleCancel = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);
  const handleConfirm = useCallback(async () => {
    if (onConfirm) await onConfirm();
  }, [onConfirm]);

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        handleCancel();
        event.preventDefault();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [handleCancel]);

  const Footer = props.confirm ? (
    <>
      <Control>
        <Button className="light" onClick={handleCancel} block>
          Quay lại
        </Button>
        <Button
          type="primary"
          onClick={handleConfirm}
          block
        >
          {props.confirmText ? props.confirmText : 'Xác nhận'}
        </Button>
      </Control>
    </>
  ) : (
    <>
      <Control>
        <Button type="primary" onClick={handleCancel} style={{ width: '100%' }}>
          {props.confirmText ? props.confirmText : 'Xác nhận'}
        </Button>
      </Control>
    </>
  );

  const icon = (() => {
    if (props.icon) return props.icon;
    if (props.type === 'warning') return <WarningIcon />;
    if (props.type === 'danger') return <CloseCircleOutlined />;
  })();
  return (
    <>
      <AnimatePresence >
        {visible && (
          <Wrap
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 1.05, opacity: 0 , display: 'none'}}
            transition={{ duration: 0.1 }}
          >
            <Main>
              <Box>
                <Icon color={props.type}>{icon}</Icon>
                <Title>{heading}</Title>
                <Body>{message}</Body>
                <Body>{subMessage}</Body>
                {Footer}
              </Box>
            </Main>
            <Mask onClick={handleCancel} />
          </Wrap>
        )}
      </AnimatePresence>
    </>
  );
}
